import { action, computed, makeAutoObservable } from "mobx";
import { SimpleSquareDevice } from "../models/Event";
import SquareDeviceEndpoints from "../api/SquareDeviceEndpoints";
import AuthStore from "./AuthStore";

class SquareDeviceStore {
    private _devices: SimpleSquareDevice[] = [];
    private _loading = false;
    private _selectedDeviceId: number | null = null;

    constructor() {
        makeAutoObservable(this);

        this.loadSelectedDeviceId();
    }

    @action
    async getSquareDevicesForClient(clientId: number) {
        if (!AuthStore.loggedIn) {
            return;
        }
        this.setLoading(true);
        try {
            const res = await SquareDeviceEndpoints.getSquareDevicesForClient(
                clientId,
            );

            this.setDevices(res);
        } catch (e) {
            console.error(e);
        } finally {
            this.setLoading(false);
        }
    }

    @action
    setDevices(devices: SimpleSquareDevice[]) {
        this._devices = devices;
    }

    @action
    setLoading(loading: boolean) {
        this._loading = loading;
    }

    @action
    selectDevice(deviceId: number) {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(
                "selectedSquareDeviceId",
                `${deviceId}`,
            );
        }
        this._selectedDeviceId = deviceId;
    }

    @computed
    get devices() {
        return this._devices;
    }

    @computed
    get loading() {
        return this._loading;
    }

    @computed
    get selectedDeviceId() {
        return this._selectedDeviceId;
    }

    @computed
    get selectedDevice() {
        return (
            this._devices.find(
                (device) => device.id === this._selectedDeviceId,
            ) ?? null
        );
    }

    @action
    private loadSelectedDeviceId() {
        if (typeof window !== "undefined") {
            const deviceId = window.localStorage.getItem(
                "selectedSquareDeviceId",
            );
            this._selectedDeviceId = deviceId ? parseInt(deviceId) : null;
        }
    }
}

export default new SquareDeviceStore();
